import { createSelector } from '@ngrx/store';

import { State } from '../reducers';

export const selectVehicleState = (state: State) => state.vehicleState;
export const selectProductForm = createSelector(selectVehicleState, (state) => state.productForm);
export const selectProductFormValues = createSelector(selectVehicleState, (state) => state.values);

export const selectSurchargesLabel = createSelector(
  selectProductForm,
  (state) => state.productForm.filter((elem) => elem.name === 'YamahaSurcharges')[0].label
);
